<script>
  import { tick } from "svelte";
  import { ButtonV2, CardV2, TextField, Snackbar } from "$lib";
  import { _ } from "$helpers/i18n.js";
  import { calculateTax, FormatNumber } from "../../../helpers/calculator";
  import { globalStore } from "../../store/globalStore";

  const { country } = globalStore;

  // Es necesario que se vuelva a calcular el resultado cuando se cambia de país (ya que los impuestos son distintos)
  $: $country, baseTaxable, (result = null);

  // Variable para el input
  let baseTaxable = null;
  let result = null;
  let resultType = null;

  // Variable para el tipo de calculo seleccionado (por defecto 'taxProduct')
  let calculateType = "taxPriceProduct";

  let resultEl;

  //Variables para Snackbar
  let showSnackbar = false;
  let snackbarMessage = "";

  async function calculate() {
    // Resetear snackbar
    showSnackbar = false;

    // Validación de valores positivos
    if (baseTaxable < 1) {
      snackbarMessage = $_("snackbar.commons.positive_values");
      showSnackbar = true;
      return;
    }

    const taxData = calculateTax(baseTaxable, $country);

    resultType = calculateType;
    if (calculateType == "taxProduct") {
      result = taxData.impuesto;
    } else if (calculateType == "taxPriceProduct") {
      result = baseTaxable + taxData.impuesto;
    }

    await tick();
    resultEl?.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }
</script>

<CardV2 variant="outlined">
  <div on:keydown={(event) => event.key == '-' && event.preventDefault()}>
    <p>{$_("taxes.calculation.first_input")}</p>
      <TextField
        placeholder="0"
        leadingText={$_("common.currency_symbol")}
        bind:value={baseTaxable}
        type="number"
        step="0.01"
        min={0}
        testId="taxProductPriceInput"
      />
  </div>
  <div class="percentage-buttons">
    <ButtonV2
      variant="secondary"
      selected={calculateType == "taxPriceProduct"}
      on:click={() => (calculateType = "taxPriceProduct")}
    >
      {$_("taxes.calculation.title_button_option")}<br />
      <strong>
        {$_("taxes.calculation.second_option_bold")}
      </strong>
    </ButtonV2>
    <ButtonV2
      variant="secondary"
      selected={calculateType == "taxProduct"}
      on:click={() => (calculateType = "taxProduct")}
    >
      {$_("taxes.calculation.title_button_option")}<br />
      <strong>
        {$_("taxes.calculation.first_option_bold")}
      </strong>
    </ButtonV2>
  </div>
  <ButtonV2
    variant="primary"
    class="btn-principal"
    on:click={calculate}
    disabled={!baseTaxable}
    dataTrack="calculate_tax"
  >
    {$_("common.calculate_button")}
  </ButtonV2>

  <!-- Campo de resultado -->
  {#if result != null}
    <div class="result-static" data-testid="taxCalculationResult" bind:this={resultEl}>
      <p>{$_(resultType == "taxProduct" ? "taxes.calculation.result_taxProduct" : "taxes.calculation.result_taxPriceProduct")}</p>
      {FormatNumber($country, result)}
    </div>
  {/if}

  {#if showSnackbar}
    <Snackbar
      variant="warning"
      visible={showSnackbar}
      message={snackbarMessage}
      on:close={() => (showSnackbar = false)}
    />
  {/if}
</CardV2>

